export const EMAIL = 'hkarmacharya@gmail.com'
export const LINKEDIN_URL = 'https://www.linkedin.com/in/harjit-karmacharya'
export const GITHUB_URL_PERSONAL = 'https://github.com/t4kaha00'
export const GITHUB_URL_PROFESSIONAL = 'https://github.com/Harjit-Kassavirtanen'
export const RESUME_PDF_URL = 'harjitkarmacharya.pdf'

// Base URL of the site hosting the Netlify functions.
// Override with REACT_APP_API_URL when running locally or from another origin.
export const API_BASE_URL =
  process.env.REACT_APP_API_URL || 'https://mern-stack-trial.netlify.app/'
